// extracted by mini-css-extract-plugin
module.exports = {"navbar":"navbar-module--navbar--8fnkJ","nav":"navbar-module--nav--25Dcz","dropdown":"navbar-module--dropdown--2BLxW"};